import React, {useCallback, useMemo} from 'react';
import {usePortfolios} from "../../../../../hooks/usePortfolios";
import {Controller, useForm} from "react-hook-form";
import * as yup from "yup";
import {
  Button, ButtonGroup, DialogActions,
  DialogContent,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import {UserRow} from "../../../hooks/useUserLoader";
import {Client} from "../../../../../api/api";
import {useApi} from "../../../../../hooks/useApi";

interface ClientPortfolioChange {
  portfolioId: number
}

const validationSchema = yup.object().shape({
  portfolioId: yup.number().required(),
})

export interface EditPortfolioProps {
  client: Client,
  activeUser: UserRow,
  onSubmit: () => void,
  onCancel: () => void,
  variant: 'BF' | 'Client'
}

export const EditPortfolio = (p: EditPortfolioProps) => {
  const {portfolios} = usePortfolios(),
    {api} = useApi()

  const portfolioId = useMemo(() => {
    return p.variant === 'BF' ? p.client.brokerPortfolioId : p.client.clientPortfolioId
  }, [p.client.brokerPortfolioId, p.client.clientPortfolioId, p.variant])

  const {errors, handleSubmit, control} = useForm<ClientPortfolioChange>({
    validationSchema,
    defaultValues: {portfolioId}
  })

  const onSubmit = useCallback(async (data: ClientPortfolioChange) => {
    const updateClient: Client = (p.variant === 'BF')
      ? {...p.client, brokerPortfolioId: data.portfolioId}
      : {...p.client, clientPortfolioId: data.portfolioId}

    await api.patchClients({
      updateClient
    })
    p.onSubmit()
  }, [api, p])

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <FormControl margin="normal" fullWidth error={!!errors?.portfolioId?.message} disabled={!portfolios}>
            <InputLabel>Portfolio:</InputLabel>
            <Controller
              name="portfolioId"
              control={control}
              as={
                <Select defaultValue={portfolioId}>
                  {portfolios?.map(portfolio => (
                    <MenuItem key={portfolio.id} value={portfolio.id}>
                      {portfolio.name}
                    </MenuItem>
                  ))}
                </Select>
              }
            />
            <FormHelperText>
              {errors.portfolioId?.message}
            </FormHelperText>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <ButtonGroup variant="outlined">
            <Button onClick={p.onCancel}>
              Cancel
            </Button>
            <Button type="submit">
              Submit
            </Button>
          </ButtonGroup>
        </DialogActions>
      </form>

    </>
  );
};
